const guardarInterfaz = objeto => {
    return {
        type: "guardarInterfaz",
        payload: objeto
    }
}

module.exports = {
    guardarInterfaz
}